// if you need to add custom js put it in here
$(window).load(function () {
    $('.HButton').bootstrapSwitch();
    $('.about-content-wrapper').matchHeight();
    $('.blogTitle').matchHeight();
    $('.pf-recent-related-product-item.product-match-height').matchHeight();
});

$(document).ready(function () {
    // Reorder items on product detail page, moves description below the price and add to cart buttons
    var $productDescription = $('#product-view-container .product-detail-description');
    if ($productDescription.length > 0) {
        $productDescription.insertAfter('#product-view-container #add-to-bag');
    }
    $('h2').each(function () {
        debugger;
        $(this).html(function (index, text) {
            return text.replace(/&nbsp;/g, '');
        });
    });

    //handle search on mobile
    $('.search-btn-mobile').click(function () {
        var isVisible = $('.header-fields').css("opacity");
        if (isVisible == '1') {
            $('.header-fields').css("display", "none");
            $('.header-fields').css("opacity", "0");
        }
        if (isVisible == '0') {
            $('.header-fields').css("display", "block");
            $('.header-fields').css("opacity", "1");
        }
    });
    //Start search by Part
    !function (a) { var b = !1; if ("function" == typeof define && define.amd && (define(a), b = !0), "object" == typeof exports && (module.exports = a(), b = !0), !b) { var c = window.Cookies, d = window.Cookies = a(); d.noConflict = function () { return window.Cookies = c, d } } }(function () { function a() { for (var a = 0, b = {}; a < arguments.length; a++) { var c = arguments[a]; for (var d in c) b[d] = c[d] } return b } function b(c) { function d(b, e, f) { var g; if ("undefined" != typeof document) { if (arguments.length > 1) { if (f = a({ path: "/" }, d.defaults, f), "number" == typeof f.expires) { var h = new Date; h.setMilliseconds(h.getMilliseconds() + 864e5 * f.expires), f.expires = h } f.expires = f.expires ? f.expires.toUTCString() : ""; try { g = JSON.stringify(e), /^[\{\[]/.test(g) && (e = g) } catch (p) { } e = c.write ? c.write(e, b) : encodeURIComponent(e + "").replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), b = encodeURIComponent(b + ""), b = b.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent), b = b.replace(/[\(\)]/g, escape); var i = ""; for (var j in f) f[j] && (i += "; " + j, !0 !== f[j] && (i += "=" + f[j])); return document.cookie = b + "=" + e + i } b || (g = {}); for (var k = document.cookie ? document.cookie.split("; ") : [], l = 0; l < k.length; l++) { var m = k[l].split("="), n = m.slice(1).join("="); '"' === n.charAt(0) && (n = n.slice(1, -1)); try { var o = m[0].replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent); if (n = c.read ? c.read(n, o) : c(n, o) || n.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent), this.json) try { n = JSON.parse(n) } catch (p) { } if (b === o) { g = n; break } b || (g[o] = n) } catch (p) { } } return g } } return d.set = d, d.get = function (a) { return d.call(d, a) }, d.getJSON = function () { return d.apply({ json: !0 }, [].slice.call(arguments)) }, d.defaults = {}, d.remove = function (b, c) { d(b, "", a(c, { expires: -1 })) }, d.withConverter = b, d } return b(function () { }) });

    // load brands
    //$.getJSON(root + '/Products/GetBrands', null, function (data) {
    //    $('#bespokeBrandSelect option').remove(); // Remove all <option> child tags.
    //    $('#bespokeBrandSelect').append('<option value="">Select Brand</option>');
    //    $.each(data, function (index, item) { // Iterates through a collection
    //        $('#bespokeBrandSelect').append( // Append an object to the inside of the select box
    //            $('<option></option>') // Yes you can do this.
    //                .text(item.name)
    //                .val(item.id)
    //        );
    //    });
    //    var brand = Cookies.get('part-search-brand');
    //    var search = Cookies.get('part-search-string');
    //    //if (brand !== undefined)
    //    //    $('#bespokeBrandSelect').val(brand);
    //    if (search !== undefined)
    //        $('#bespokePartSearch').val(search);
    //});

    // handle search radios
    $('.search-radio').click(function () {
        var type = $(this).data('radio-type');
        if (type === 'search-prod') {
            $('.mini-search-col2').fadeOut();
            $('#bespokeProdSearch').show();
            $('#bespokePartSearch').hide();
        } else {
            $('.mini-search-col2').fadeIn();
            $('#bespokePartSearch').show();
            $('#bespokeProdSearch').hide();
        }
    });

    // product search handler
    $("#bespokeProdSearch").autocomplete({
        source: root + 'Products/AutoComplete',
        minLength: 2,
        select: function (event, ui) {
            window.location.href = ui.item.url;
        }
    });
    $('#bespokeProdSearch, #bespokePartSearch').keypress(function (e) {
        if (e.which == 13) {
            $('#bespokeSearchBtn').click();
        }
    });
    $('#bespokeSearchBtn').click(function () {
        var type = $('input[name=BespokeSearchRadio]:checked').data('radio-type');
        if (type === 'search-prod') {
            if ($('#bespokeProdSearch').val() !== '')
                window.location.href = root + 'Products/Search/?search=' + encodeURIComponent($('#bespokeProdSearch').val());
            else
                alert('Please enter a search term');
        } else {
            if ($('#bespokePartSearch').val() !== '') {
                var brand = 0;
                if (brand !== '') {
                    Cookies.set('part-search-brand', brand);
                    Cookies.set('part-search-string', $('#bespokePartSearch').val());
                    window.location.href = root + 'Products/PartNumberSearch/?search=' + encodeURIComponent($('#bespokePartSearch').val());
                } else {
                    alert('Please select a brand');
                }
            } else {
                alert('Please enter a part number');
            }
        }
        return false;
    });
    $("#bespokePartSearch").autocomplete({
        source: root + 'Parts/AutoComplete',
        minLength: 2,
        select: function (event, ui) {
            window.location.href = ui.item.url;
        }
    });
     //End search by Part
});
